import React from 'react';
import SIcon from './SIcon';
import { faSignalStrong } from '@fortawesome/pro-duotone-svg-icons';

const Icon = props => <SIcon {...props} icon={faSignalStrong} fa />;

export default Icon;
